import React, { type ReactElement } from 'react';

import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Switch as AntSwitch, type SwitchProps as AntSwitchProps } from 'antd';
import { type SwitchChangeEventHandler } from 'antd/es/switch';
import classNames from 'classnames';

export interface SwitchProps extends AntSwitchProps {
  checked: boolean;
  label: string;
  onChange?: SwitchChangeEventHandler;
  help?: string;
}

export default function Switch({
  label,
  checkedChildren = <CheckOutlined className="pt-[2px] lg:pt-1" />,
  unCheckedChildren = <CloseOutlined className="pt-0 lg:pt-1" />,
  className,
  help,
  ...rest
}: SwitchProps): ReactElement {
  return (
    <>
      <div
        className={classNames(
          'flex h-8 flex-row gap-3 px-1 py-[6px]',
          className
        )}
      >
        {label && (
          <label className="flex-1 text-xs text-black-default">{label} </label>
        )}
        <AntSwitch
          {...rest}
          className="switch"
          checkedChildren={checkedChildren}
          unCheckedChildren={unCheckedChildren}
        />
      </div>
      {help && (
        <div className="text-2xs font-medium text-tangerine-500">{help}</div>
      )}
    </>
  );
}
